export default {
  id: "totalInventoryValue",
  name: "",
  description: "",
  report: {
    name: "Total inventory value",
    template: "custom",
    chartType: "NUMBER",
    config: {
      dataType: "single",
      dataSet: "InventoryItem",
      dimensions: [],
      measures: ["InventoryItem.qty_on_hand_retail_amount"],
      sort: {
        direction: "",
        by: "",
      },
      filters: [],
      compare: false,
      limit: "10",
      rowTotals: false,
      stacked: false,
      points: false,
      colorTheme: "default",
    },
  },
};
